import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { MasterPlansRepository } from "../../repositories";
import { Observable } from "rxjs";
import { EditMasterPlanRequest } from "../../domain";

@Injectable({ providedIn: 'root' })
export class EditMasterPlanUsecase implements UseCase<EditMasterPlanRequest, boolean> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: EditMasterPlanRequest): Observable<boolean> {
    return this.masterPlanRepository.editMasterPlan(params);
  }
}
